const { adminCall } = require("./_utils")

module.exports = {
  draft: data => adminCall("service.draft", data),
  create: data => adminCall("service.create", data),
  modify: data => adminCall("service.modify", data),
  remove: uid => adminCall("service.remove", { uid }),
  migrate: data => adminCall("service.migrate", data)
}
